export default __webpack_public_path__ + "media/images/66-fa141cc14f783cdbec82d410249b3938.jpg";